import UsedMachines from "@/pages/UsedMachines";

export default function SpareParts() {
  return <UsedMachines listingType="spare" title="Spare Parts" noun="spare parts" categoryType="spare" />;
}
